import "./RheemWaterHeaterService.module.css";
import Header from "@/reusable_sections/Header";
import RheemHero from "./sections/RheemHero";
import RheemServices from "./sections/RheemServices";
import RheemFaq from "./sections/RheemFaq";
import Footer from "@/reusable_sections/Footer";
export default function RheemWaterHeaterServicePage() {
  return <div>
      <Header />
      <RheemHero />
      <RheemServices />
      <RheemFaq />
      <Footer />
    </div>;
}